import MainIcons from '@/icons/main';
import styles from './styles.module.css';
import { brand } from '@/commonTypes';

type BrandHeroInfoProps = {
  item?: brand;
};

export default function BrandInfo({ item }: BrandHeroInfoProps) {
  return (
    <div>
      <h1 className={styles.title}>{item?.brand}</h1>

      <div className={styles.meta}>
        <span className={styles.metaItem}>
          <MainIcons.GlobeIcon width={'16px'} height={'16px'} />
          <strong>{item?.country?.title}</strong>
        </span>

        <span className={styles.dot} />

        <span className={styles.metaItem}>
          <MainIcons.CalendarIcon width={'16px'} height={'16px'} />
          <strong>تأسیس {item?.founded}</strong>
        </span>

        <span className={styles.dot} />

        <span className={styles.metaItem}>
          <MainIcons.carIcon width={'16px'} height={'16px'} />
          <strong>{item?.modelsCount} مدل فعال</strong>
        </span>
      </div>

      <p className={styles.description}>{item?.description}</p>
    </div>
  );
}
